import { types } from './nota-entrada.actions'
import { Reducer } from '../../services/reducer.factory'
import storage from '../../services/stoage.service'

const initialState = {
  id: 'notaEntrada',
  selectedFilters: [],
  showHideColumns: [
    {
      label: 'Seleção',
      value: {
        field: 'multiselect',
        header: 'Seleção',
        columnKey: 'multiselect',
        visible: true,
      },
    },
    {
      label: 'Código',
      value: {
        field: 'oid',
        header: 'Código',
        columnKey: 'oid',
        columnSortField: 'oid',
        sortable: true,
        filter: true,
        visible: true,
      },
    },
    {
      label: 'Emissão',
      value: {
        field: 'dataEmissao',
        header: 'Emissão',
        columnKey: 'dataEmissao',
        sortable: true,
        filter: true,
        columnSortField: 'dataEmissao',
        fieldFormatter: 'formatarData',
        visible: true,
      },
    },
    {
      label: 'Entrada',
      value: {
        field: 'dataEntrada',
        header: 'Entrada',
        columnKey: 'dataEntrada',
        sortable: true,
        filter: true,
        columnSortField: 'dataEntrada',
        fieldFormatter: 'formatarData',
        visible: true,
      },
    },
    {
      label: 'Status',
      value: {
        field: 'status',
        header: 'Status',
        columnKey: 'status',
        sortable: true,
        filter: true,
        columnSortField: 'status',
        fieldFormatter: 'getValue',
        visible: true,
      },
    },
    {
      label: 'Valor',
      value: {
        field: 'valorNota',
        header: 'Valor',
        columnKey: 'valorNota',
        sortable: true,
        filter: true,
        columnSortField: 'valorNota',
        fieldFormatter: 'formatarDinheiro',
        visible: true,
      },
    },
    {
      label: 'Número',
      value: {
        field: 'numero',
        header: 'Número',
        columnKey: 'numero',
        sortable: true,
        filter: true,
        columnSortField: 'numero',
        visible: true,
      },
    },
    {
      label: 'Série',
      value: {
        field: 'serie',
        header: 'Série',
        columnKey: 'serie',
        sortable: true,
        filter: true,
        columnSortField: 'serie',
        visible: true,
      },
    },
    {
      label: 'Chave',
      value: {
        field: 'chave',
        header: 'Chave',
        columnKey: 'chave',
        sortable: true,
        filter: true,
        columnSortField: 'chave',
        visible: true,
      },
    },
    {
      label: 'Unidade',
      value: {
        field: 'unidade_sigla',
        columnKey: 'unidade.sigla',
        sortable: true,
        header: 'Unidade',
        filter: true,
        columnSortField: 'unidade.sigla',
        relacionamento: ['unidade'],
        fieldJoin: 'sigla',
        visible: true,
      },
    },
    {
      label: 'Nome fantasia',
      value: {
        field: 'fornecedor_nomeFantasia',
        header: 'Nome fantasia',
        columnKey: 'fornecedor',
        columnSortField: 'fornecedor.nomeFantasia',
        relacionamento: ['fornecedor'],
        fieldJoin: 'nomeFantasia',
        visible: true,
        sortable: true,
        filter: true,
      },
    },
    {
      label: 'Razão social',
      value: {
        field: 'fornecedor_nome',
        header: 'Razão social',
        columnKey: 'fornecedor',
        columnSortField: 'fornecedor.nome',
        relacionamento: ['fornecedor'],
        fieldJoin: 'nome',
        visible: true,
        sortable: true,
        filter: true,
      },
    },
  ],
  columns: [],
  currentRecord: {
    oid: '',
    unidade: '',
    chave: '',
    numero: '',
    serie: '',
    dataEmissao: new Date(),
    valorNota: 0.0,
    status: 0,
    observacao: '',
    dataEntrada: '',
    dataImportacao: '',
    dataVencimento: '',
    fornecedor: '',
    oidLancamentoFinanceiro: '',
    itens: [],
  },
  messages: null,
  usaListDto: false,
}

const reducer = new Reducer(initialState, types)

export function CRUDNotaEntradaReducer(state, action) {
  if (state) {
    state.messages = storage.getAppLabels('religiao')
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  switch (action.type) {
    case types.RESET:
      return reset(state, action)
    case types.MAKE_NEW:
      return initialize(state)
    default:
      return state
  }
}

const initialize = (state) => {
  return checkUnidadeCorrente(state)
}

const checkUnidadeCorrente = (state) => {
  const currentRecord = state.currentRecord
  const currentUnit = storage.getUnit()
  if (currentUnit) {
    currentRecord.unidade = { id: currentUnit.oid, value: currentUnit.sigla }
    return Object.assign({}, state, { currentRecord: currentRecord })
  }
  return state
}

function reset(state, action) {
  return { ...state, currentRecord: initialState.currentRecord, records: [], selectedFilters: [] }
}
